import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {DropDown, TextInput, TextArea} from '../form';
import {submitFeedbackOverlay, loading} from '../../redux/actions';

const OverlaySubmitFeedback = (props) => (
  <div className="overlay-wrapper">
    <div className="overlay-box">
      <div className="overlay-close" onClick={props.dismissOverlay} />
      <div className="title">Submit feedback</div>
      <div className="body">
        <div className="overlay-comments">
          {props.status === 'successful' ? (
            <div>
              <div className="form-block hlp-pb-50">
                Thank you for your feedback, we will get back to you shortly.
              </div>
              <div className="actions">
                <button className="btn invert" onClick={props.dismissOverlay}>
                  Close
                </button>
              </div>
            </div>
          ) : (
            <div className="form-block hlp-pb-50">
              <TextInput
                onChangeHandler={(e) => props.onChange('email', e.target.value)}
                type="email"
                label="Email address"
                labelPositionTop
                error={props.errors.email}
              />
              <TextInput
                onChangeHandler={(e) => props.onChange('name', e.target.value)}
                type="text"
                label="Name (optional)"
                labelPositionTop
              />
              <TextInput
                onChangeHandler={(e) =>
                  props.onChange('institution', e.target.value)
                }
                type="text"
                label="Institution (optional)"
                labelPositionTop
              />
              <DropDown
                label="Process"
                options={[{value: '', label: ''}, ...props.processes]}
                labelPositionTop
                error={props.errors.process}
                onChangeHandler={(e) => props.onChange('process', e)}
              />
              <TextArea
                label="Feedback"
                labelPositionTop
                error={props.errors.feedback}
                onChange={(e) => props.onChange('feedback', e.target.value)}
              />
            </div>
          )}
        </div>
      </div>

      {props.status !== 'successful' ? (
        <div className="actions">
          <button className="btn invert" onClick={props.dismissOverlay}>
            Cancel
          </button>
          <button
            className="btn primary"
            onClick={() => props.onConfirmAction()}>
            Submit feedback
          </button>
        </div>
      ) : (
        <div />
      )}
    </div>
  </div>
);

class SubmitFeedback extends Component {
  componentWillMount() {
    this.setState({feedbackProcesses: '', formErrors: {}});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitFeedbackOverlayActive === true) {
      this.setState({submitData: {}, status: null, formErrors: {}});
      console.log('url is ', process.env.REACT_APP_URL)
      axios.post(`${process.env.REACT_APP_URL}api/processes/all`).then((response) => {
        this.setState({
          feedbackProcesses: response.data,
          submitData: {process: response.data[0].value},
        });
      });
    }
  }

  submitForm() {
    this.props.loading(true);
    this.setState({formErrors: {}});
    axios
      .post(`${process.env.REACT_APP_URL}api/submitfeedback`, this.state.submitData)
      .then(() => {
        this.props.loading(false);
        this.setState({status: 'successful'});
      })
      .catch((err) => {
        this.props.loading(false);
        this.setState({formErrors: err.response.data.errors});
      });
  }
  dismissOverlay() {
    this.props.submitFeedbackOverlay(false);
  }

  render() {
    return (
      <div>
        {this.props.submitFeedbackOverlayActive && (
          <OverlaySubmitFeedback
            dismissOverlay={() => this.dismissOverlay()}
            processes={this.state.feedbackProcesses}
            onChange={(prop, value) =>
              this.setState({
                submitData: {...this.state.submitData, [prop]: value},
              })
            }
            onConfirmAction={() => this.submitForm()}
            errors={this.state.formErrors}
            status={this.state.status}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {submitFeedbackOverlayActive} = state.god;
  return {submitFeedbackOverlayActive};
};

export default connect(mapStateToProps, {
  submitFeedbackOverlay,
  loading,
})(SubmitFeedback);
